import gql from 'graphql-tag'

const jobStatus = gql`
  query jobStatus(
    $job_type_id: Float!
    $order: String
    $exclude_closed_status: Boolean
    $workspace_id: Float!
  ) {
    jobStatus(
      job_type_id: $job_type_id
      order: $order
      exclude_closed_status: $exclude_closed_status
      workspace_id: $workspace_id
    ) {
      id
      name
      color
      urutan
      job_type {
        name
      }
      job_order {
        next_job_status_id
      }
      type
    }
  }
`

export default jobStatus
